import jsonParseSafe from '@/common/utils/jsonParseSafe';

type TaskResultError = {
  message?: string;
};

const parseTaskResultErrors = (errors: unknown): TaskResultError[] => {
  if (errors == null) {
    return [];
  }

  if (typeof errors === 'string') {
    const parsed = jsonParseSafe<TaskResultError[] | { errors?: unknown }>(errors);

    if (Array.isArray(parsed)) {
      return parsed;
    }

    if (parsed && typeof parsed === 'object' && 'errors' in parsed) {
      return parseTaskResultErrors(parsed.errors);
    }

    return errors ? [{ message: errors }] : [];
  }

  if (Array.isArray(errors)) {
    return errors;
  }

  return [];
};

export const getTaskResultErrorMessage = (
  task: { result?: Record<string, unknown> | null; error?: string | null }
): string | undefined => {
  const messages = parseTaskResultErrors(task.result?.errors)
    .map(({ message }) => message)
    .filter((message): message is string => Boolean(message));

  if (messages.length) {
    return messages.join('\n');
  }

  return task.error || undefined;
};

export default getTaskResultErrorMessage;
